import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_ROUTE_DATA,
  CLEAR_ROUTES_DATA,
  FLAG_GETTING_ROUTES_DATA,
  FLAG_ROUTE_DATA_ACTIVITY,
  GET_ROUTE_DATA,
  GET_ROUTES_DATA,
} from '../types/route';
import { ROUTE_DATA_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingRoutesData = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ROUTES_DATA,
    payload: flag,
  });

const flagRouteDataActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ROUTE_DATA_ACTIVITY,
    payload: flag,
  });
const getRoutesData = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingRoutesData(true));
    const query = tableFilters;
    const url = `${ROUTE_DATA_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const routeDatas = await response.json();
    dispatch({
      type: GET_ROUTES_DATA,
      payload: routeDatas,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingRoutesData(false));
  }
};

const getRouteData =
  async ({ routeDataId }) =>
  async (dispatch) => {
    try {
      dispatch(flagRouteDataActivity(true));
      const url = `${ROUTE_DATA_ENDPOINT}/${routeDataId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const routeData = await response.json();
      dispatch({
        type: GET_ROUTE_DATA,
        payload: routeData,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagRouteDataActivity(false));
    }
  };

const clearRoutesData = () => (dispatch) =>
  dispatch({
    type: CLEAR_ROUTES_DATA,
  });

const clearRouteData = () => (dispatch) =>
  dispatch({
    type: CLEAR_ROUTE_DATA,
  });

export {
  flagGettingRoutesData,
  getRoutesData,
  getRouteData,
  clearRoutesData,
  clearRouteData,
};
